import { render, staticRenderFns } from "./approveDialog.vue?vue&type=template&id=35ab5250&scoped=true&"
import script from "./approveDialog.vue?vue&type=script&lang=js&"
export * from "./approveDialog.vue?vue&type=script&lang=js&"
import style0 from "./approveDialog.vue?vue&type=style&index=0&id=35ab5250&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab5250",
  null
  
)

export default component.exports